import { Passkeys } from '@laravel/passkeys'
import { usePasskeyRegister } from '@laravel/passkeys/vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores'

const routes = {
  options: `${import.meta.env.API_HOST_URL}/api/passkeys/register/options`,
  submit: `${import.meta.env.API_HOST_URL}/api/passkeys`
}

export const usePasskeyRegistration = ({ onSuccess, onError } = {}) => {
  const { accessToken } = storeToRefs(useAuthStore())
  const { register: registerPasskey, isLoading, isSupported, error } = usePasskeyRegister({ routes, onSuccess, onError })

  const register = name => {
    // Registration is bearer-authenticated, but this client only supports a
    // global header via configure() — there's no per-call auth hook — so the
    // current access token is pushed in right before each ceremony rather
    // than once at boot, where it would go stale after a token refresh.
    Passkeys.configure({ fetch: { headers: { Authorization: `Bearer ${accessToken.value}` } } })
    return registerPasskey(name)
  }

  return { register, isLoading, isSupported, error }
}
